import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$(function () {
  // Global
  // ---------------------------------------------------------------------------

  // Cache elements for performance.
  var $document = $(document);
  var $window = $(window);
  var $html = $('html');
  var $body = $('body');

  // Gallery
  // ---------------------------------------------------------------------------

  var $gallery = $('.js-gallery');

  $gallery.flickity({
    wrapAround: true,
    imagesLoaded: true,
    lazyLoad: true,
    pageDots: false,
    draggable: true,
    arrowShape: {
      x0: 37.5,
      x1: 60,
      y1: 20,
      x2: 60,
      y2: 10,
      x3: 60,
    },
  });

  $gallery
    .find('.flickity-prev-next-button.previous')
    .addClass('gallery__button is-previous');
  $gallery
    .find('.flickity-prev-next-button.next')
    .addClass('gallery__button is-next');

  // Form Watch
  // ---------------------------------------------------------------------------

  $('.js-form-watch')
    .find('.js-form-control')
    .on('change', function () {
      $(this).closest('.js-form-watch').submit();
    });

  // Accordions
  // ---------------------------------------------------------------------------

  var $accordionToggle = $('.js-accordion-toggle');

  $accordionToggle.on('click', function () {
    var $accordion = $(this).closest('.js-accordion');
    var $accordions = $(this).closest('.js-accordions');
    if ($accordion.hasClass('is-toggled')) {
      $accordion.removeClass('is-toggled');
    } else {
      $accordions.find('.is-toggled').removeClass('is-toggled');
      $accordion.addClass('is-toggled');
      if ($accordion.find('.js-gallery').length) {
        console.log('Accordions found');
        $accordion.find('.js-gallery').flickity('resize');
      }
    }
  });

  // Search Overlay
  // ---------------------------------------------------------------------------

  // Cache elements for performance.
  var $searchOverlay = $('.js-search-overlay');
  var $searchOverlayToggle = $('.js-search-overlay-toggle');
  var $searchOverlayForm = $('.js-search-overlay-form');
  var $searchOverlayControl = $('.js-search-overlay-control');

  /**
   * Function that handles opening the search overlay and focuses the input.
   */
  function openSearchOverlay() {
    // Used for hiding the vertical scroll bar on the page when open.
    $html.addClass('is-locked');
    $searchOverlay.addClass('is-toggled');
    $searchOverlayControl.focus();
  }

  /**
   * Function that handles closing the search overlay.
   */
  function closeSearchOverlay() {
    // Used for hiding the vertical scroll bar on the page when open.
    $html.removeClass('is-locked');
    $searchOverlay.removeClass('is-toggled');
  }

  /**
   * Function that handles toggling the search overlay state.
   */
  function toggleSearchOverlay() {
    if ($searchOverlay.hasClass('is-visible')) {
      closeSearchOverlay();
    }
    if (!$searchOverlay.hasClass('is-visible')) {
      openSearchOverlay();
    }
  }

  $searchOverlay.on('click', closeSearchOverlay);
  $searchOverlayToggle.on('click', toggleSearchOverlay);
  // Prevent clicks from within the form from closing (as a result of the
  // event listener bound to `$searchOverlay`).
  $searchOverlayForm.on('click', function (event) {
    event.stopPropagation();
  });

  // Menu
  // ---------------------------------------------------------------------------

  $('.js-menu-toggle').on('click', function () {
    $('.js-menu').toggleClass('is-toggled');
    $('html').toggleClass('is-locked');
  });

  // Alert
  $('.js-alert-close').on('click', function (event) {
    $(this).closest('.js-alert').addClass('is-closed');
  });

  // Dropdowns
  // ---------------------------------------------------------------------------

  const $dropdowns = $('.js-dropdowns');
  const $dropdown = $('.js-dropdown');
  const $dropdownToggle = $('.js-dropdown-toggle');

  $dropdownToggle.on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    const $this = $(this);
    const $dropdowns = $this.closest('.js-dropdowns');
    const $dropdown = $this.closest('.js-dropdown');

    if ($dropdown.hasClass('is-toggled')) {
      $dropdown.removeClass('is-toggled');
    } else {
      $dropdowns.find('.is-toggled').removeClass('is-toggled');
      $dropdown.toggleClass('is-toggled');
    }
  });

  $dropdowns.on('click', function (event) {
    event.stopPropagation();
  });

  $html.on('click', function (event) {
    $dropdowns.find('.is-toggled').removeClass('is-toggled');
  });
});
